import { FunctionComponent } from 'react';
import { Shimmer } from '../Shimmer/Shimmer';
import { ResponsiveContainer, MOBILE_TEXT_INSET } from '../ResponsiveContainer';

/**
 * Contenido neutro de la carcasa mientras no hay nada propio de la pantalla que
 * mostrar: la sesión todavía no llegó o el chunk de la ruta sigue bajando. Solo
 * el encabezado (título + bajada, con las medidas del hero de las pantallas) y
 * bloques sueltos: no anticipa una forma que la pantalla real después contradiga.
 */
export const ShellContentSkeleton: FunctionComponent = () => (
  <div aria-busy="true">
    <ResponsiveContainer>
      {/* Mismas medidas que AtelierHero: pt-3/pb-4 (sm: pt-4/pb-5), título de 32 px en el
          celular y 44 px en escritorio, 4 px hasta la bajada. Al llegar la pantalla el
          título queda donde estaba el bloque gris. */}
      <div className={`flex flex-col gap-1 pt-3 pb-4 sm:pt-4 sm:pb-5 ${MOBILE_TEXT_INSET}`}>
        <Shimmer className="h-[32px] w-[60%] sm:h-[44px] sm:w-[340px]" />
        <Shimmer className="h-[18px] w-[70%] sm:h-[22px] sm:w-[280px]" rounded="rounded" />
      </div>
      {/* Bloques = tarjetas blancas con las barras grises adentro (propuesta q1p). */}
      <div className="flex flex-col gap-3 pt-4">
        {['', 'opacity-70', 'opacity-40'].map((fade) => (
          <div
            key={fade || 'full'}
            className={`flex h-[104px] w-full flex-col justify-center gap-2.5 rounded-2xl bg-frost-card px-6 shadow-frost-card ${fade}`}
          >
            <Shimmer className="h-2.5 w-[45%] sm:w-[220px]" />
            <Shimmer className="h-2 w-[30%] sm:w-[150px]" />
          </div>
        ))}
      </div>
    </ResponsiveContainer>
  </div>
);
